import * as stylex from '@stylexjs/stylex'
import { colors } from '../tokens/colors.stylex'

export const ytColors = {
  brand: '#FF9800',
  primary50: '#FFFAF1',
  primary100: '#FFF3E0',
  primary200: '#FFE0B2',
  primary300: '#FFCD80',
  primary400: '#FFB84D',
  primary500: '#FFA826',
  primary600: '#FF9800',
  primary700: '#F57D00',
  primary800: '#EF6D00',
  primary900: '#E65200',

  secondary50: '#FFFAF1',
  secondary100: '#FFF3E0',
  secondary200: '#FFE0B2',
  secondary300: '#FFCD80',
  secondary400: '#FFB84D',
  secondary500: '#FFA826',
  secondary600: '#FF9800',
  secondary700: '#F57D00',
  secondary800: '#EF6D00',
  secondary900: '#E65200',
}

export const colorTheme = stylex.createTheme(colors, ytColors)
